import React from 'react';
import PropTypes from 'prop-types';
import s from './ErrorItem.module.scss';
import Image from '../Image';
import Button from '../Button/Button';
import Richtext from '../Richtext/Richtext';
import AnimatedLogo from '../AnimatedLogo/AnimatedLogo';
import Modal from '../Modal/Modal';
import SupportFormModal from '../SupportFormModal/SupportFormModal';
import Icon from '../Icon';

const ErrorItem = ({
    label,
    title,
    description,
    richText,
    image,
    links = [],
}) => {
    return (
        <div className={s.Root}>
            <div className={s.Container}>
                <div className={s.ImageContainer}>
                    <div className={s.Image}>
                        <Image useCover={true} useCaption={false} {...image} />
                    </div>
                    <div className={s.Icon}>
                        <Icon name="NotFound" />
                    </div>
                </div>
                <div className={s.Text}>
                    <span className={s.Label}>{label}</span>
                    <h2 className={s.Title}>{title}.</h2>
                    <span className={s.Description}>{description}</span>
                    <div className={s.Links}>
                        {links &&
                            links.map((link, index) => (
                                <Button
                                    key={index}
                                    modifier="Secondary"
                                    size="Large"
                                    {...link}
                                />
                            ))}
                        {/* <Modal
                            isCustomButton={false}
                            buttonTitle="Support"
                            title="TBox Support">
                            <SupportFormModal {...supportForm} />
                        </Modal> */}
                    </div>
                    <Richtext text={richText} />
                </div>
            </div>
        </div>
    );
};

ErrorItem.propTypes = {
    label: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    richText: PropTypes.string,
    image: PropTypes.object,
    icon: PropTypes.object,
    links: PropTypes.array,
};

export default ErrorItem;
